// extracted by mini-css-extract-plugin
export default {"headerForm":"FormStyle_headerForm__isnfj","Selectdropdown":"FormStyle_Selectdropdown__wzdg5"};